import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Play from './pages/Play';
import Learn from './pages/Learn';
import Collect from './pages/Collect';
import NotFound from './pages/NotFound';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/collect" element={<Collect />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/learn" element={<Learn />} />
            {/* <Route path="/learn/locations" element={<Locations />} />
            <Route path="/learn/biomes" element={<Biomes />} />
            <Route path="/learn/life_kingdoms" element={<LifeKingdoms />} />
            <Route path="/learn/geological_periods" element={<GeologicalPeriods />} />
            <Route path="/learn/trophic_level" element={<TrophicLevel />} />
            <Route path="/learn/phenomena" element={<Phenomena />} /> */}
            <Route path="/play" element={<Play />} />
            <Route path="/support" element={<Contact />} />  {/* Backwards compatibility */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
